<template>
<span :class="primitiveBaseClasses">
    <div style="position:relative">
        <label class="amf-input-label" v-if="$_showLabel">{{label}}</label>
        <div class="input-group">
            <input v-if="!maskOn"
                :class="['form-control', { error: hasError }]"
                type="text"
                :value="internalValue"
                @paste.prevent="onPaste"
                @input="inputChanged"
                :maxlength="format.length"
                :placeholder="placehold"
                :disabled="$_disabled"
                :title="title || label"
            />
            <input v-else
                :class="['form-control', { error: hasError }]"
                type="text"
                :value="maskedValue"
                :title="title || label"
                :disabled="true"
            />
            <div v-if="maskFormat" class="input-group-append" @click="toggleMask">
                <span class="input-group-text">
                    <span v-if="maskOn" class="fa fa-pencil"></span>
                    <span v-else class="fa fa-eye-slash"></span>
                </span>
            </div>
            <div v-if="showCopyButton" class="input-group-append" @click="copyValue">
                <span class="input-group-text">
                    <span class="fa fa-clipboard"></span>
                </span>
            </div>
        </div>
        <div class="error-div">
            {{validationMessage}}
        </div>
    </div>
</span>
</template>
<script>
import primitiveMixin from './primitive-mixin';
import { v } from "framework";
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
const DEBUG = true;
const BLANK = '_';

export default {
    mixins: [primitiveMixin],
    props: {
        label: { type: String },
        value: { default: {} },
        valueWithFormat: { type: Boolean, default: false },
        placehold: { type: String, required: false },
        title: { type: String, required: false },
        format: { type: String, required: true }, // ex: ___-__-____
        maskFormat: { type: String, required: false }, // ex: ***-**-____
        noTracking: { type: Boolean, default: true },
        showCopyButton: { type: Boolean, default: false },
    },
    data() {
        return {
            internalValue: this.valueWithFormat ? this.value : this.formatStr(this.value),
            maskOn: !!this.maskFormat,
        }
    },
    computed: {
        maskedValue() {
            let maskedValue = "";
            let internalValueIndex = -1;
            let minIndex = this.maskFormat.length - this.internalValue.length;

            for (let i = minIndex; i < this.maskFormat.length; i++) {
              internalValueIndex++;

              maskedValue += this.maskFormat[i] !== BLANK ? this.maskFormat[i] : this.internalValue[internalValueIndex] || BLANK;
            }

            return maskedValue;
        },
        isDateFormat() {
            return this.format == '__/__/____';
        },
    },
    created() {
        if(this.value instanceof Date) {
            this.internalValue = this.formatDate(this.value);
        }
        else if(this.valueWithFormat) {
            this.internalValue = this.value;
        }
        else {
            this.internalValue = this.formatStr(this.value);
        }
    },
    methods: {
        toggleMask(){
            this.maskOn = !this.maskOn;
        },
        copyValue(){
            this.$copyText(this.value).then(() => {
                toastService.success(`Copied ${this.label} to clipboard`);
            }, () => {
                toastService.error(`Error copying ${this.label} to clipboard`);
            });
        },
        onPaste() {
            let paste = (event.clipboardData || window.clipboardData).getData('text');
            let cleanStr = this.removeSpecialChars(paste);
            // console.log("onPaste newValue:", paste, cleanStr);

            if(this.isDateFormat && cleanStr.length != 8) {
                let dateArr = paste.split('/');

                if(dateArr && dateArr.length == 3) {
                    dateArr[0] = leftPadZeros(dateArr[0]);
                    dateArr[1] = leftPadZeros(dateArr[1]);
                    cleanStr = dateArr.join('');
                }
            }
            this.internalValue = this.formatStr(cleanStr);

            function leftPadZeros(num) {
                return num && !isNaN(num) && num < 10 ? '0' + num : num;
            }
        },
        inputChanged(newValue) {
            newValue = (' ' + newValue.target.value).slice(1);
            // console.log("inputChanged newValue:", newValue);
            this.internalValue = newValue;
        },
        formatDate(dateStr) {
            return !dateStr ? dateStr : dateStr.toLocaleDateString('en-US',
	            { day: '2-digit', month: '2-digit', year: 'numeric', });
        },
        formatStr(str) {
            if(!str) return "";
            let newStr = "";
            let pos = 0;

            this.format.split('').forEach(char => {
                if(pos >= str.length) return;

                if(char != BLANK) {
                    newStr = newStr + char;
                }
                else if(str.charAt(pos)) {
                    newStr = newStr + str.charAt(pos++);
                }
            });

            return newStr;
        },
        removeSpecialChars(str) {
            return str ? str.replace(/[^a-z0-9]/gi,'') : "";
        },
        dateGroupFix(str, lastChar, maxlength, zeroPadding) {
            str = (' ' + str).slice(1);
            if(lastChar == '/') str = str + lastChar;
            let partStr = str.slice(0, -1);
            // if(DEBUG) console.log("dateGroupFix str:", str, partStr, lastChar);

            if(this.isNumeric(lastChar)) {
                if(str.length == maxlength + 1) {
                    return partStr + '/' + lastChar;
                }
                else if(str.length <= maxlength) {
                    return str;
                }
            }

            if(lastChar == '/' && zeroPadding) {
                if(str.length == (maxlength + 1)) {
                    return str;
                }
                else if(str.length == maxlength) {
                    return str;
                }
            }

            return partStr;
        },
        fixDateLastChar(str) {
            if(!str) return "";
            str = (' ' + str).slice(1);
            let lastChar = str.charAt(str.length - 1);
            let newDate = str.slice(0, -1);
            let dateArr = str.split('/').filter(x => x);

            if(dateArr.length == 1) {
                newDate = this.dateGroupFix(dateArr[0], lastChar, 2, true);
            }
            else if(dateArr.length == 2) {
                newDate = dateArr[0] + '/' + this.dateGroupFix(dateArr[1], lastChar, 2, true);
            }
            else if(dateArr.length == 3) {
                newDate = dateArr[0] + '/' + dateArr[1] + '/' + this.dateGroupFix(dateArr[2], lastChar, 4, false);
            }

            // if(DEBUG) console.log("fixDateLastChar newDate:", newDate, dateArr);
            return newDate;
        },
        fixLastChar(str, format) {
            if(!str) return "";
            str = (' ' + str).slice(1);
            let partStr = str.slice(0, -1);
            let lastChar = str.charAt(str.length - 1);
            let formatChar = format.charAt(str.length - 1);

            if(formatChar == BLANK) {
                return this.isAlphaNumeric(lastChar) ? str : partStr;
            }
            else if(formatChar == lastChar) {
                return str;
            }
            else {
                return this.isAlphaNumeric(lastChar) ? partStr + formatChar + lastChar : partStr;
            }
        },
        isNumeric(str) {
            return /^[0-9]+$/i.test(str);
        },
        isAlphaNumeric(char) {
            return /^[a-z0-9]+$/i.test(char);
        },
        updateInternalValue(str) {
            this.internalValue = str;
        },
    },
    watch: {
        value(newValue) {
            // if(DEBUG) console.log("watch value:", newValue);

            if(!newValue) {
                this.internalValue = newValue;
            }
            else if(newValue instanceof Date) {
                this.internalValue = this.formatDate(newValue);
            }
            else if(this.valueWithFormat) {
                this.internalValue = newValue;
            }
            else {
                this.internalValue = this.formatStr(newValue);
            }
        },
        internalValue(newValue) {
            let fixedStr = this.isDateFormat ? this.fixDateLastChar(newValue) : this.fixLastChar(newValue, this.format);
            // if(DEBUG) console.log("watch internalValue:", newValue, fixedStr);

            if(newValue != fixedStr) {
                this.updateInternalValue(fixedStr);
            }
            else if(this.valueWithFormat) {
                this.$emit('input', fixedStr);
            }
            else {
                this.$emit('input', this.removeSpecialChars(fixedStr));
            }
        },
        maskOn(newValue) {
          this.$emit('mask-on', newValue);
        }
    }
}
</script>

<style lang="scss" scoped>
.input-group-append {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfFormatInput.vue